// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../../styles/variables.css\"","primary":"#56CCF2","textDefault":"#808080","wrapper":"_1yBjaCmfSp4eCkpPsOu2C_","container":"_3cL_YdawR8ktbfT2Qa22xQ","desktop-container":"_3xwWUaieh5b9RDYbB2YmPU","row":"_2CTZgawJ4LI1YYvqzUnlp3","cell":"_1nMuYL9CKqmOBVedVmCK6h","title-cell":"_wt1mH6d_YAv0uYG-EqJ4","value":"_3LVvAhSG3Uqw2BQImsgEjg","column":"_39oiy7wyEiRH5qhQ3YI8a9","mob-row":"_2xZxYSoengO6_lmhF9jNID","answer":"_24Fyxpaq45MytQGaAOzkwf","input":"_3nRmrX-jFeKpNHZ1aSwq4h"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/RecoveryPlan/components/StressTable.mod.css
// module id = 2121
// module chunks = 0